import { isWeb } from "@tamagui/constants";
import { getAllSelectors } from "./insertStyleRule.js";
import { names, normalizeColor } from "./normalizeColor.js";
import { normalizeStylePropKeys } from "./normalizeStylePropKeys";
const colorCache = {};
function normalizeValueWithProperty(value, property) {
  if (value in colorCache) {
    return colorCache[value];
  }
  if (property && property in unitlessNumbers) {
    return value;
  }
  let res = value;
  if (property && (property in normalizeStylePropKeys || value in names)) {
    res = normalizeColor(value);
    colorCache[value] = res;
  } else if (process.env.TAMAGUI_TARGET === "web" && typeof value === "number" && (property === void 0 || !(property in unitlessNumbers || property in stringNumbers))) {
    res = `${value}px`;
  } else if (isWeb && property !== void 0 && property in stringNumbers) {
    res = `${res}`;
  }
  return res;
}
const stringNumbers = {
  zIndex: true
};
const unitlessNumbers = {
  WebkitLineClamp: true,
  animationIterationCount: true,
  aspectRatio: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexBasis: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowGap: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnGap: true,
  gridColumnStart: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zoom: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  shadowOpacity: true
};
const rcache = {};
function reverseMapClassNameToValue(key, className) {
  const selectors = getAllSelectors();
  const cssRule = selectors[className];
  if (rcache[cssRule])
    return rcache[cssRule];
  if (!cssRule) {
    return;
  }
  const cssVal = cssRule.replace(/.*:/, "").replace(/;.*/, "").trim();
  let res;
  if (cssVal.startsWith("var(")) {
    res = cssVal;
  } else if (unitlessNumbers[key]) {
    res = +cssVal;
  } else if (cssVal.endsWith("px")) {
    res = +cssVal.replace("px", "");
  } else {
    res = cssVal;
  }
  rcache[cssRule] = res;
  if (process.env.NODE_ENV === "development") {
    if (typeof res === "number" && isNaN(res)) {
      console.log("Tamagui invalid parsed value, NaN:", {
        res,
        cssVal,
        cssRule,
        key,
        className
      });
    }
  }
  return res;
}
export {
  normalizeValueWithProperty,
  reverseMapClassNameToValue
};
//# sourceMappingURL=normalizeValueWithProperty.js.map
